export default __webpack_public_path__ + "static/media/landing-scott-icon.08ee2567.png";